import { useEffect, useState } from "react";

function useZXing() {
  const [zxingReady, setZxingReady] = useState(undefined);
  const [ZXing, setZXing] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const isScriptLoaded = document.getElementById("zxing-script");
    if (isScriptLoaded) {
      if (window.ZXingBrowser) { // Check for ZXingBrowser
        setZxingReady(true);
        setZXing(window.ZXingBrowser); // Assign ZXingBrowser
      } else {
        const checkInterval = setInterval(() => {
          if (window.ZXingBrowser) { // Check for ZXingBrowser
            clearInterval(checkInterval);
            setZxingReady(true);
            setZXing(window.ZXingBrowser); // Assign ZXingBrowser
          }
        }, 100);
      }
      return;
    }

    const script = document.createElement("script");
    script.id = "zxing-script";
    script.src = "https://unpkg.com/@zxing/browser@latest";
    script.async = true;

    script.onload = () => {
      setZxingReady(true);
      setZXing(window.ZXingBrowser); // Assign ZXingBrowser
    };
    script.onerror = () => {
      setZxingReady(false);
      setError("Failed to load ZXing-JS script.");
    };

    document.body.appendChild(script);

    return () => {
      // Don't remove the script
    };
  }, []);

  return {
    zxingReady,
    ZXing,
    error,
  };
}

export default useZXing;